<section [ngClass]="!dashboardView && !gamificationView && userMode == 'supervisor'? '': 'd-none'"
  class="active-agents">
  <section
    class="{{showViolationHistoryWidget?'h-100 bg-agent-layout bg-secondary float-start border b-color-100 side-bar': 'h-100 bg-agent-layout bg-secondary float-start border b-color-100 no-side-bar'}}">
    <div class="col-md-12" style="height: 100%;width: 100%;">
      <div class="container-fulid gap-2 ">

        <div class="row" *ngIf="!hideLoading">
          <div class="col-md-12 top-50 position-absolute text-primary">

            <h3 style="margin: 0 auto; width: 200px">
              <span class="sr-only" class="spinner-border m-1" style="width: 5rem; height: 5rem;"
                [ngClass]=" hideLoading ? 'd-none': 'd-block'"></span>
            </h3>
            <h3 style="margin: 0 auto; width: 200px"> {{loadingAgentDetailsLabel}} ...</h3>
          </div>
        </div>

        <div class="float-start mx-2 agent-list-w" [ngClass]="archivedView ? 'archived-view' : ''">
          <h3 class="d-flex text-primary float-start font-large h3-font f-w-500 lh-1"
            style="height: 32px;justify-content: space-between;align-items: center;margin-bottom: 0;margin-top:0;">
            <i (click)="goBackToAllAgents()" title="{{goBackLabel}}" class="fal fa-arrow-circle-left back-btn"
              style="height: 100%;align-items: center;"></i>
            <div class="float-start back-btn-sidetext" *ngIf="hideLoading"
              style="height: 100%;display: flex;align-items: center;">
              <span style="font-weight: bold;">{{archivedView? archivedAgentsLabel : activeAgentsLabel}}</span>
            </div>
          </h3>
          <p *ngIf="hideLoading" data-bs-toggle="tooltip" data-bs-placement="top" title="{{agentCountLabel}}"
            class="bgred rounded-pill d-flex float-start label-agent text-white">
            {{agentsCount}}
          </p>
          <button type="button" (click)="toggleGlobalFilterPopup()" *ngIf="hideLoading && !archivedView"
            data-bs-toggle="tooltip" data-bs-placement="top" title="Filter By" id="___unified_global_filter_btn"
            class="hover-coursor position-relative bg-white border-0 font-md py-1 rounded-pill border-1 align-self-center">
            <i class="fal fa-filter text-dark-p" id="___unified_global_filter_btn_icon"
              *ngIf="isFilterEnabled() === false"></i>
            <i class="fas fa-filter text-dark-p" id="___unified_global_filter_btn_icon"
              *ngIf="isFilterEnabled() === true"></i>
          </button>
          <unified-global-filters (ClosePopUpEvent)="hideGlobalFilterPopup()" [isPopupHidden]="isGlobalFilterHidden"
            [isScreenblockFilterEnabled]="isScreenblockFilterEnabled"
            [ngClass]="isGlobalFilterHidden === true ? 'd-none' : ''">
          </unified-global-filters>
        </div>

        <div class="float-start col-md-3 searchbox-w px-1" *ngIf="hideLoading">
          <div class="input-group search-container">
            <input type="text" class="text-break form-control search-bar rounded-pill" placeholder="{{searchLabel}}"
              aria-label="Search" [(ngModel)]="searchText" maxlength="30" (ngModelChange)="searching($event)"
              aria-describedby="basic-addon2">
            <div class="input-group-append search-icon">
              <div class="btn"
                style="padding: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">
                <i class="fas fa-search"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="float-start" *ngIf="hideLoading">
          <div class="input-group d-flex px-1 hover-coursor">
            <div>
              <p class="btn bg-outline-secondary px-1 py-0 rounded-circle" title="{{refreshLabel}}"
                data-bs-toggle="tooltip" data-bs-placement="top" data-trigger="hover"
                class="input-group-append  text-primary mb-0 mt-1" (click)="refresh()">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" class="bi bi-refresh"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </p>
            </div>
          </div>
        </div>

        <div *ngIf="hideLoading" class="px-2 float-end mt-2 d-inline-flex" style="align-items: center;">
          <h6 class="text-primary float-start font-md me-1" style="margin: 0;" [ngClass]="selectedLanId ? 'd-none':'' ">
            {{teamCheckInLabel}}
          </h6>
          <label [ngClass]="selectedLanId ? 'd-none':'' ">
            <input class="toggle-checkbox" (change)=teamCheckInService.toggleTeamCheckIn() type="checkbox"
              [ngModel]="teamCheckInService.getIsTeamCheckInActive()">
            <div class="toggle-slot">
              <div class="sun-icon-wrapper hover-coursor">
              </div>
              <div class="toggle-button activetoggle hover-coursor"></div>
              <div class="moon-icon-wrapper">
              </div>
            </div>
          </label>
        </div>
        <div *ngIf="hideLoading" class="px-2 float-end mt-2 d-inline-flex" style="align-items: center;">
          <h6 class="text-primary float-start font-md me-1" style="margin: 0;" [ngClass]="selectedLanId ? 'd-none':'' ">
            {{archivedView? archivedLabel: activeLabel}}
          </h6>
          <label [ngClass]="selectedLanId ? 'd-none':'' ">
            <input class="toggle-checkbox" (change)=toggleView() [(ngModel)]="archivedView" type="checkbox"
              id="flexSwitchCheckDefault1">
            <div class="toggle-slot">
              <div class="sun-icon-wrapper hover-coursor">
              </div>
              <div class="toggle-button activetoggle hover-coursor"></div>
              <div class="moon-icon-wrapper">
              </div>
            </div>
          </label>
        </div>
      </div>

      <div #scrollContainerRef class="text-center float-start w-100 height-90vh overflow-auto custom-area mt-2">
        <div *ngIf="hideLoading" class="grid gap-2 float-start w-100 
        {{
          showViolationHistoryWidget?'grid gap-2 float-start w-100' 
        : 
        'grid gap-2 float-start w-100'
        }}">

          <div *ngIf="archivedView && archivedTeamCount == 0" class="nodata">


            <img alt="No Data" class="w-100 height-90vh" src="assets/images/no-data.svg" />
            <p class="text-primary mt--20">{{noAgentsArchivedLabel}}</p>

          </div>

          <div *ngIf="!paginationAgents.length && !archivedView">
            <img alt="No Data" class="w-100" src="assets/images/no-data.svg" />
            <p class="text-primary">{{noRecordsMatchedLabel}}</p>
          </div>

          <div class="app-single-agent" *ngFor="let singleAgent of paginationAgents;"
            [ngClass]="!archivedView && !singleAgent.IsArchived ? '': 'd-none'">
            <app-single-agent [agent]=singleAgent (click)="selectAgent(singleAgent.LanID)" [archivedView]="archivedView"
              [isSidebar]="showViolationHistoryWidget"></app-single-agent>
          </div>
          <div class="app-single-agent" *ngFor="let singleAgent of paginationAgents;"
            [ngClass]="archivedView && singleAgent.IsArchived ? '': 'd-none'">
            <app-single-agent [agent]=singleAgent (click)="selectAgent(singleAgent.LanID)" [archivedView]="archivedView"
              [isSidebar]="showViolationHistoryWidget"></app-single-agent>
          </div>
        </div>
      </div>
      <div class="col-md-12 w-100 text-center float-start pagination"
        [ngClass]="paginationAgents && paginationAgents.length > 0 ? '': 'd-none'">


        <pagination-template #p="paginationApi" id="paginationid" (pageChange)="pageChanged($event)" class="m-auto">

          <ul class="ngx-pagination responsive">
            <li><span class="pagesize-title">{{itemsPerPageLabel}}</span></li>
            <li>
              <select [ngModel]="config.itemsPerPage" (ngModelChange)="pageSizeChange($event)"
                class="pagesize form-select">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </li>
            <li class="pagination-previous" [class.disabled]="p.isFirstPage()">
              <a *ngIf="!p.isFirstPage()" (click)="p.previous()"> {{previousLabel}} </a>
            </li>

            <li *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
              <a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
                <span>{{ page.label }}</span>
              </a>
              <div *ngIf="p.getCurrent() === page.value">
                <span>{{ page.label }}</span>
              </div>
            </li>
            <li class="small-screen">{{p.getCurrent()}} / {{totalPages}}</li>
            <li class="pagination-next" [class.disabled]="p.isLastPage()">
              <a *ngIf="!p.isLastPage()" (click)="p.next()"> {{nextLabel}} </a>
            </li>
          </ul>
          <ul style="display: none">
            <ng-container *ngIf="!isFilterEnabled()">
              <li *ngFor="let item of agentListInfoService.GetAllAgentInfo() | paginate: config">
              </li>
            </ng-container>
            <ng-container *ngIf="isFilterEnabled()">
              <li *ngFor="let item of paginationAgents | paginate: config">
              </li>
            </ng-container>
          </ul>

        </pagination-template>

      </div>
    </div>

  </section>
  <div class="right-panel-grid">
    <div class="row">
      <!-- violation history-->
      <div *ngIf="selectedLanId"
        class="{{showChatWidget ? 'col-md-12 px-1 pb-1': showViolationHistoryWidget?'col-md-12 pb-1': 'd-none'}}">
        <app-voilation-history [AgentLanId]="selectedLanId" [AgentProfilePic]="selectedProfilePic"
          [supervisorCanViewMedia]="supervisorCanViewMedia" [violationsPerPage]="violationsPerPage">
        </app-voilation-history>
      </div>
      <!-- violation count-->

      <div *ngIf="selectedLanId" class="{{showChatWidget ? 'col-lg-6 p-1':'d-none'}}">
        <app-violation-count [connectionTime]=connectionTime [AgentLanId]="selectedLanId"></app-violation-count>
        <ng-container *ngIf="appConfig.settings.defaults.EnableAgentTime">
          <app-total-agent-time
            [agentLoginStatus]="agentListInfoService.GetLoginStatusMessage(selectedLanId) == 'LoggedIn' ? true : false"
            [AgentTime]="selectedTime"></app-total-agent-time>
        </ng-container>
      </div>

      <!-- chat box -->
      <div class="{{selectedLanId ? 'col-lg-6 p-1':'d-none'}}">
        <app-chat (addChatToEventHistory)="addChatToEvents($event)" [selectedProfilePic]="selectedProfilePic"
          [AgentLanId]="selectedLanId" [supervisorCanViewMedia]="supervisorCanViewMedia">
        </app-chat>
      </div>
    </div>

    <app-events-filter *ngIf="selectedLanId" [violations]="selectedAgentViolations" [AgentLanId]="selectedLanId">
    </app-events-filter>
  </div>
</section>
<section>
  <app-mainsuper-admin [ngClass]="!dashboardView && !gamificationView && userMode == 'superadmin'? '': 'd-none'">
  </app-mainsuper-admin>
</section>

<section [ngClass]="dashboardView? '': 'd-none'" style="height: calc(100vh - 80px);">
  <app-dashboard></app-dashboard>
</section>
<section [ngClass]="gamificationView? '': 'd-none'" style="height: calc(100vh - 80px);">
  <app-gamification></app-gamification>
</section>

<div class="modal" [ngStyle]="{'display':hideConfimationPopUp?'none':'block'}" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{pendingStealthRequestsLabel}}</h5>
        <button type="button" class="close btn" data-dismiss="modal" (click)="hideConfimationPopUp = true"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <p>{{concludeStealthRequestsLabel}} </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn button-primary" (click)="hideConfimationPopUp = true">{{okLabel}}</button>
      </div>
    </div>
  </div>
</div>


<div class="modal" [ngStyle]="{'display':hideWaitingPopUp?'none':'block'}" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{pleaseWaitLabel}} ... </h5>
        <button type="button" class="close btn" data-dismiss="modal" (click)="hideWaitingPopUp = true"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <p>{{updatingLabel}} ...</p>
      </div>
    </div>
  </div>
</div>